<section class="bg-black-wheels" [ngClass]="themeClass('subscribe-section1')">
  <div class="container no-btn-wrap">
    <div class="col-12">
      <div class="row  align-items-center justify-content-center mb-4">
        <div class="col-12 col-md-7 col-lg-5">
          <div [innerHTML]="index9?.short_description || ''"></div>
        </div>
        <div class="col-12 col-md-5">
          <form [formGroup]="emailForm" (ngSubmit)="onSubmit.emit()">
            <div class="position-relative input-subscribe">
              <input class="form-control wheel-mail" id="email_address_id" name="email_address_id"
                [placeholder]="placeholder_subscribe" type="email" aria-label="Email" formControlName="email" />
              <button class="pink-b-btn position-absolute top-50 end-0 translate-middle-y me-1 me-lg-2" type="submit">
                <i class="fa fa-chevron-right"></i>
              </button>
              <button type="submit" class=" btn-subscribe-ch15"><span class="">Subscribe <i
                    class="fa-solid fa-arrow-right-long"></i></span></button>
            </div>
          </form>
          <div class="error-wheels-msg" *ngIf="errorMessage">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>